.ucs-page{width:100%;background:var(--page-bg);color:var(--text);font-family:var(--font-family);overflow:clip}
.ucs-page *{box-sizing:border-box}
.ucs-page svg{fill:currentColor;flex-shrink:0}
.ucs-page h1,.ucs-page h2,.ucs-page h3,.ucs-page h4,.ucs-page p,.ucs-page dl,.ucs-page dd,.ucs-page figure{margin:0}
.ucs-page :where(button,summary){font:inherit;color:inherit;cursor:pointer}
.ucs-page button{touch-action:manipulation}
.ucs-page a{color:inherit;text-decoration:none}
.ucs-page p{font-size:15px;line-height:1.65;color:var(--muted)}
.ucs-page h2{line-height:1.14;letter-spacing:-1.5px}
.ucs-page h3{line-height:1.3;letter-spacing:-.45px}
.ucs-page h4{line-height:1.35;letter-spacing:-.3px}
.ucs-page button:focus-visible,.ucs-page a:focus-visible,.ucs-page summary:focus-visible,.ucs-page [tabindex]:focus-visible{outline:3px solid var(--focus);outline-offset:4px}
.ucs-page [hidden]{display:none!important}
/* The shared app reset suppresses button outlines with !important. Restore
   keyboard focus only inside the public showcase; keep other app controls intact. */
.ucs-page button:focus-visible{outline:3px solid var(--focus)!important}
.ucs-hero-stage{text-align:left;margin:38px auto 0;padding:30px 40px 18px;border-radius:20px;max-width:1040px}
.ucs-product-frame{background:var(--surface);border:1px solid var(--border);border-radius:15px;box-shadow:var(--shadow);overflow:hidden;min-width:0}
.ucs-frame-bar{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:14px 21px;border-bottom:1px solid var(--border);background:var(--surface);font-size:13px}
.ucs-brand{display:flex;align-items:center;gap:8px;white-space:nowrap}
.ucs-brand strong{font-size:14px;font-weight:600}
.ucs-work-label{margin-left:5px;padding-left:12px;border-left:1px solid var(--border);color:var(--muted);font-size:12px}
.ucs-sample-label{font-size:11px;color:var(--muted)}
.ucs-artifact-name{padding:12px 22px;display:flex;gap:9px;align-items:center;background:var(--panel);border-bottom:1px solid var(--border);font-size:13px;color:var(--muted);overflow-wrap:anywhere}
.ucs-hero-conversation{padding:26px 28px 20px}
.ucs-user-prompt{border-radius:16px;padding:18px 20px;background:var(--panel);max-width:650px;margin-left:auto;margin-bottom:28px}
.ucs-user-prompt>p{color:var(--text);font-size:16px;line-height:1.5;margin-top:10px}
.ucs-answer-heading{display:flex;align-items:center;gap:10px;font-size:17px;font-weight:550;margin-bottom:12px}
.ucs-answer-heading h2{flex:1;min-width:0;line-height:1.35;letter-spacing:-.4px}
.ucs-response>p{font-size:15px;color:var(--text);line-height:1.65}
.ucs-response>p+p{margin-top:14px}
.ucs-completed{margin-left:auto;font-size:11px;font-weight:400;color:var(--muted);display:flex;align-items:center;gap:5px}
.ucs-hero-result{display:grid;grid-template-columns:minmax(0,1fr) 190px;gap:30px;align-items:center}
.ucs-response{min-width:0;color:var(--text)}
.ucs-result-count{padding:22px;border-left:1px solid var(--border)}
.ucs-result-count>strong{font-size:45px;line-height:1.2;font-weight:550;letter-spacing:-1.5px}
.ucs-result-count>strong>span{font-size:22px;font-weight:400;color:var(--muted)}
.ucs-result-count p{font-size:13px;margin-top:6px;line-height:1.4}
.ucs-result-count>span{display:block;font-size:11px;color:var(--muted);margin-top:16px}
.ucs-source-strip{display:flex;align-items:center;gap:9px;flex-wrap:wrap;border-top:1px solid var(--border);margin-top:14px;padding-top:15px}
.ucs-source-strip>span{font-size:12px;color:var(--muted);margin-right:auto}
.ucs-source-strip>button{display:flex;gap:7px;align-items:center;border:1px solid var(--border);border-radius:6px;background:var(--panel);padding:7px 10px;font-size:11px;min-height:34px}
.ucs-source-strip>button:hover,.ucs-source-strip>button[aria-expanded=true]{background:var(--selected-bg);border-color:var(--selected-border)}
.ucs-page .ucs-demo-note{text-align:center;font-size:11px;margin-top:15px;color:var(--muted)}
.ucs-workflows{display:grid;grid-template-columns:minmax(300px,.82fr) minmax(0,1.8fr);gap:48px;margin-top:40px;align-items:start}
.ucs-workflow-menu{display:flex;flex-direction:column;gap:0;border-top:1px solid var(--border)}
.ucs-workflow-menu>button{display:flex;align-items:center;justify-content:space-between;gap:12px;text-align:left;padding:18px 2px;min-height:57px;border:none;border-bottom:1px solid var(--border);background:transparent;font-size:16px;color:var(--muted);transition:color .15s ease}
.ucs-workflow-menu>button[aria-selected=true]{color:var(--text);font-weight:550;border-bottom-color:var(--border)}
.ucs-workflow-menu>button:hover{color:var(--text)}
.ucs-workflow-menu>button>div{opacity:.4}
.ucs-workflow-menu>button[aria-selected=true]>div{opacity:1}
.ucs-workflow-panels{min-width:0}
.ucs-workflow-panels>[role=tabpanel]:not([hidden]){animation:ucs-panel-in .18s ease-out both}
@keyframes ucs-panel-in{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}
.ucs-workflow-copy{margin-top:26px}
.ucs-workflow-caption{margin-bottom:20px}
.ucs-workflow-caption h3{line-height:1.25;letter-spacing:-.7px}
.ucs-workflow-caption p{margin-top:9px;max-width:650px}
.ucs-workflow-stage{padding:23px;border-radius:16px;min-width:0}
.ucs-output-heading{padding:22px 24px 18px}
.ucs-output-heading p{font-size:12px;margin-top:6px}
.ucs-record-choices{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;padding:0 22px 20px}
.ucs-record-choices>button{background:var(--panel);text-align:left;padding:12px;border:1px solid var(--border);border-radius:8px;min-height:71px;display:flex;flex-direction:column;gap:5px}
.ucs-record-choices>button>span{font-size:11px;color:var(--muted)}
.ucs-record-choices>button>strong{font-size:12px;font-weight:500;line-height:1.5}
.ucs-record-choices>button[aria-pressed=true]{border-color:var(--selected-border);background:var(--selected-bg)}
.ucs-evidence-detail{border-top:1px solid var(--border);display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1.1fr)}
.ucs-evidence-source{padding:24px;background:var(--panel)}
.ucs-evidence-source h4{margin-top:10px}
.ucs-page .ucs-meta{font-size:12px;margin-top:8px}
.ucs-evidence-source blockquote{border-left:2px solid var(--border);margin:22px 0 0;padding-left:14px;font-size:15px;line-height:1.65;color:var(--text)}
.ucs-evidence-finding{padding:24px}
.ucs-status{display:inline-flex;align-items:center;gap:6px;font-size:11px;line-height:1.4;background:var(--panel);color:var(--muted);border:1px solid var(--border);border-radius:6px;padding:6px 8px;margin-bottom:13px}
.ucs-evidence-finding>p{font-size:14px;color:var(--text)}
.ucs-control{margin-top:20px;padding-top:16px;border-top:1px solid var(--border)}
.ucs-control strong,.ucs-request strong{font-size:12px;font-weight:550}
.ucs-control p,.ucs-request p{font-size:12px;margin-top:6px;line-height:1.6}
.ucs-request{margin-top:20px}
.ucs-kicker{font-size:11px;font-weight:550;line-height:1.5;color:var(--muted)}
.ucs-evidence-detail-compact{margin-top:18px;border:1px solid var(--border);border-radius:8px;overflow:hidden}
.ucs-evidence-detail-compact .ucs-evidence-source,.ucs-evidence-detail-compact .ucs-evidence-finding{padding:20px}
.ucs-filter{display:flex;gap:6px;flex-wrap:wrap;padding:0 22px 18px}
.ucs-filter>button{padding:8px 10px;min-height:35px;border-radius:6px;background:var(--surface);border:1px solid var(--border);font-size:11px}
.ucs-filter>button[aria-pressed=true]{background:var(--accent-fill);border-color:var(--selected-border);color:var(--on-accent)}
.ucs-table-scroll{overflow-x:auto;max-width:100%;overscroll-behavior-x:contain}
.ucs-page table{border-collapse:collapse;width:100%;text-align:left;min-width:520px;font-size:12px}
.ucs-page thead th{background:var(--panel);font-size:11px;font-weight:550;color:var(--muted);padding:12px 16px;white-space:nowrap}
.ucs-page tbody th,.ucs-page td{padding:13px 16px;border-bottom:1px solid var(--border);font-weight:400;vertical-align:middle;line-height:1.5}
.ucs-row-button{display:flex;align-items:flex-start;flex-direction:column;text-align:left;border:0;background:transparent;padding:0;min-height:45px;max-width:180px}
.ucs-row-button strong{font-size:11px;color:var(--muted);font-weight:550}
.ucs-row-button span{font-size:12px;margin-top:3px;line-height:1.4}
.ucs-row-button small{font-size:10px;margin-top:4px;color:var(--muted)}
.ucs-selected-row{background:var(--selected-bg)}
.ucs-table-status{display:inline-block;padding:4px 7px;border:1px solid var(--border);border-radius:5px;background:var(--panel);color:var(--muted);font-size:10px;line-height:1.45}
.ucs-record-present{border-color:var(--border);background:var(--panel);color:var(--muted)}
.ucs-page .ucs-output-footnote{padding:15px 22px;font-size:11px}
.ucs-email{padding:4px 26px 26px}
.ucs-draft-label{display:inline-flex;align-items:center;gap:6px;font-size:11px;color:var(--muted);background:var(--panel);padding:5px 8px;border-radius:5px;margin-bottom:14px}
.ucs-email dl{border-bottom:1px solid var(--border);padding-bottom:18px;margin-bottom:20px}
.ucs-email dl>div{display:grid;grid-template-columns:50px 1fr;gap:8px;margin-top:8px;font-size:12px;line-height:1.5}
.ucs-email dt{color:var(--muted)}
.ucs-email dd{color:var(--text)}
.ucs-email>p{font-size:13px;color:var(--muted)}
.ucs-email ol{padding-left:20px;margin:20px 0}
.ucs-email li{padding-left:5px;margin-bottom:16px;font-size:12px}
.ucs-email li>strong{font-size:12px;font-weight:550}
.ucs-email li p{margin-top:5px;font-size:13px;line-height:1.6}
.ucs-page .ucs-email-note{font-size:11px;color:var(--muted);border-top:1px solid var(--border);padding-top:15px}
.ucs-workflow-prompt{margin-top:0;background:var(--panel);border:1px solid var(--border);padding:20px 22px;border-radius:10px}
.ucs-workflow-prompt>p{margin-top:8px;font-size:13px;line-height:1.6;color:var(--muted)}
.ucs-inputs{margin-top:14px;min-width:0}
.ucs-inputs-compact{margin-top:0}
.ucs-files{display:flex;flex-wrap:wrap;gap:7px;min-width:0}
.ucs-file{display:inline-flex;align-items:center;gap:7px;min-height:33px;background:var(--surface);border:1px dashed var(--border);border-radius:6px;padding:7px 9px;font-size:13px;line-height:1.4;text-align:left;max-width:100%}
.ucs-file>span:last-child{overflow-wrap:anywhere;min-width:0}
.ucs-file-icon{display:flex;align-items:center;justify-content:center;flex-shrink:0;color:var(--muted)}
.ucs-file-icon.table{color:var(--muted)}
.ucs-file-icon.file-pdf{color:var(--muted)}
.ucs-file[aria-expanded=true],.ucs-file:hover{border-color:var(--selected-border);background:var(--selected-bg)}
.ucs-file-preview{padding:18px;margin-top:12px;border:1px solid var(--border);border-radius:8px;background:var(--surface);max-height:420px;overflow:auto;overscroll-behavior:contain;text-align:left}
.ucs-file-preview-heading{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}
.ucs-file-preview h4{margin-top:5px}
.ucs-file-preview>p{font-size:12px;margin-top:9px}
.ucs-file-preview .ucs-table-scroll{margin-top:16px}
.ucs-source-list>div{border-top:1px solid var(--border);margin-top:14px;padding-top:12px}
.ucs-source-list dt{font-size:12px;font-weight:550;line-height:1.5}
.ucs-source-list dd{font-size:12px;line-height:1.6;color:var(--muted);margin-top:5px}
.ucs-icon-button{display:flex;align-items:center;justify-content:center;border:0;background:var(--panel);border-radius:50%;width:32px;height:32px;flex-shrink:0}
.ucs-prompt-grid{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:20px;margin-top:34px}
.ucs-prompt-tile{grid-column:span 2}
.ucs-prompt-tile:where(:last-child:nth-child(3n+1)){grid-column:3 / span 2}
.ucs-prompt-tile:where(:nth-last-child(2):nth-child(3n+1)){grid-column:2 / span 2}
.ucs-prompt-tile:where(:last-child:nth-child(3n+2)){grid-column:4 / span 2}
.ucs-prompt-tile{break-inside:avoid;transition:background .18s ease,border-color .18s ease;display:flex;flex-direction:column;align-items:stretch;width:100%}
.ucs-prompt-tile:hover,.ucs-prompt-tile:focus-within{background:var(--selected-bg);border-color:var(--selected-border)}
.ucs-prompt-tile-heading{display:flex;align-items:center;gap:7px;font-size:11px;color:var(--muted);margin-bottom:16px}
.ucs-prompt-tile h3{line-height:1.35;letter-spacing:-.3px;margin-bottom:12px}
.ucs-prompt-tile>p{font-size:13px;line-height:1.65;color:var(--muted)}
.ucs-prompt-tile .ucs-inputs{margin-top:17px;padding-bottom:22px}
.ucs-faq>h2{text-align:left;margin-inline:0;line-height:1.2}
.ucs-faq details{border-top:1px solid var(--border);padding:20px 0}
.ucs-faq details:last-child{border-bottom:1px solid var(--border)}
.ucs-faq summary{display:flex;align-items:center;justify-content:space-between;gap:14px;list-style:none;font-size:15px;line-height:1.5}
.ucs-faq summary::-webkit-details-marker{display:none}
.ucs-faq details[open] summary>div{transform:rotate(45deg)}
.ucs-faq details p{margin-top:13px;font-size:14px;line-height:1.65}
.ucs-hero-stage,.ucs-workflow-stage,.ucs-card-composition,.ucs-blueprint-stage{background-color:var(--panel);background-image:var(--preview-gradient)}
.ucs-workflow-sidebar{min-width:0}
.ucs-workflow-prompt .ucs-files{gap:8px}
.ucs-workflow-prompt .ucs-file{width:100%;font-size:12px;min-height:40px}
.ucs-workflow-caption p{font-size:14px}
.ucs-rail-controls{display:flex;align-items:center;justify-content:center;gap:12px;margin:28px 0 26px}
.ucs-rail-controls button{display:flex;align-items:center;justify-content:center;width:44px;height:44px;border:1px solid var(--border);border-radius:50%;background:var(--surface);transition:background .18s ease,border-color .18s ease}
.ucs-rail-controls button:hover:not(:disabled){background:var(--selected-bg);border-color:var(--selected-border)}
.ucs-rail-controls button:disabled{opacity:.3;cursor:default}
.ucs-capability-rail{display:flex;gap:24px;overflow-x:auto;scroll-snap-type:x mandatory;overscroll-behavior-x:contain;padding:5px 3px 18px;scrollbar-width:thin;scrollbar-color:var(--border) transparent}
.ucs-feature-card{flex:0 0 calc((100% - 48px)/3.2);min-width:320px;scroll-snap-align:start;overflow:hidden;display:flex;flex-direction:column;transition:box-shadow .2s ease,border-color .2s ease}
.ucs-feature-card:hover,.ucs-feature-card:focus-within{border-color:var(--selected-border);box-shadow:var(--shadow)}
.ucs-feature-copy{padding:28px 27px 22px;min-height:180px}
.ucs-feature-copy h3{line-height:1.28;letter-spacing:-.6px;text-wrap:balance}
.ucs-feature-copy p{font-size:14px;line-height:1.6;margin-top:12px}
.ucs-feature-card>a{display:flex;align-items:center;justify-content:space-between;gap:10px;padding:20px 27px 23px;font-size:13px;margin-top:auto}
.ucs-feature-card>a:hover{text-decoration:underline;text-underline-offset:4px}
.ucs-card-composition{position:relative;height:390px;overflow:hidden;isolation:isolate}
.ucs-mini-paper{position:absolute;top:22px;left:54px;right:18px;min-height:340px;background:var(--surface);border:1px solid var(--border);border-radius:13px;padding:20px 20px 25px;box-shadow:var(--shadow)}
.ucs-mini-paper h4{line-height:1.45;margin:17px 0}
.ucs-mini-paper-bar{display:flex;align-items:center;gap:7px;font-size:10px;color:var(--muted);line-height:1.5}
.ucs-mini-paper-bar svg{flex-shrink:0}
.ucs-mini-paper-bar>span{min-width:0}
.ucs-page .ucs-mini-paper table{min-width:0;table-layout:fixed;font-size:11px}
.ucs-mini-paper table th,.ucs-mini-paper table td{padding:11px 7px;font-size:10px}
.ucs-mini-paper table th:first-child{width:46%}
.ucs-mini-paper table th>strong,.ucs-mini-paper table th>span{display:block}
.ucs-mini-paper table th>strong{font-weight:550}
.ucs-mini-paper table th>span{margin-top:5px;color:var(--muted)}
.ucs-mini-finding>strong{display:block;font-size:12px;line-height:1.5;margin:10px 0}
.ucs-mini-finding blockquote{font-size:12px;line-height:1.6;margin:12px 0;padding-left:10px;border-left:2px solid var(--border);color:var(--muted)}
.ucs-mini-finding>p{font-size:12px;line-height:1.6}
.ucs-mini-finding .ucs-status{font-size:10px;margin:0}
.ucs-mini-request>p{font-size:11px;line-height:1.65;margin-top:14px}
.ucs-mini-request>p>strong{display:block;margin-bottom:4px;font-weight:550;color:var(--text)}
.ucs-mini-policy>p{font-size:12px;line-height:1.7}
.ucs-mini-policy>div{display:flex;gap:6px;margin-top:16px}
.ucs-mini-policy>div>span{font-size:10px;padding:5px 7px;border-radius:5px;background:var(--panel);color:var(--muted)}
.ucs-floating-prompt{position:absolute;left:18px;right:28px;bottom:28px;z-index:2;background:var(--surface);border:1px solid var(--border);border-radius:17px;padding:15px 15px 17px;box-shadow:var(--shadow-soft)}
.ucs-visual-files{display:flex;gap:8px;overflow:hidden}
.ucs-visual-files>.ucs-visual-file{flex:0 0 185px}
.ucs-visual-file{display:flex;align-items:center;gap:9px;background:var(--surface);border:1px solid var(--border);border-radius:9px;padding:9px;min-width:0;text-align:left}
.ucs-visual-file-icon{display:flex;align-items:center;justify-content:center;width:34px;height:39px;border-radius:7px;background:var(--panel);color:var(--muted);flex-shrink:0}
.ucs-file-type-table .ucs-visual-file-icon{background:var(--panel);color:var(--muted)}
.ucs-file-type-file-pdf .ucs-visual-file-icon{background:var(--panel);color:var(--muted)}
.ucs-visual-file>span:last-child{min-width:0}
.ucs-visual-file strong{display:block;font-size:11px;line-height:1.4;font-weight:500;overflow-wrap:anywhere}
.ucs-visual-file small{display:block;font-size:9px;line-height:1.4;color:var(--muted);margin-top:3px}
.ucs-floating-prompt>p{font-size:14px;line-height:1.55;color:var(--text);margin-top:13px;padding-right:29px}
.ucs-preview-send{position:absolute;right:15px;bottom:17px;background:var(--accent-fill);color:var(--on-accent);display:flex;align-items:center;justify-content:center;width:26px;height:26px;border-radius:50%}
.ucs-blueprint-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:28px;margin-top:36px}
.ucs-blueprint-card{min-width:0;scroll-margin-top:100px;display:flex;flex-direction:column}
.ucs-blueprint-copy{min-height:114px}
.ucs-blueprint-copy h3{letter-spacing:-.65px;line-height:1.3;text-wrap:balance;max-width:530px}
.ucs-blueprint-copy p{font-size:14px;margin-top:10px;line-height:1.6;max-width:550px}
.ucs-blueprint-choices{display:flex;gap:7px;flex-wrap:wrap;margin:16px 0}
.ucs-blueprint-choices button{border:1px solid var(--border);border-radius:7px;background:var(--surface);min-height:36px;padding:8px 13px;font-size:12px;transition:background .18s ease,border-color .18s ease}
.ucs-blueprint-choices button[aria-pressed=true]{background:var(--selected-bg);border-color:var(--selected-border);color:var(--muted)}
.ucs-blueprint-stage{display:grid;grid-template-columns:minmax(0,1.05fr) minmax(0,1fr);gap:14px;padding:30px 24px 42px;border:1px solid var(--border);border-radius:18px;min-height:430px;align-items:start;isolation:isolate;flex:1}
.ucs-blueprint-answer{padding:19px 18px 22px;background:var(--surface);border:1px solid var(--border);border-radius:15px;box-shadow:var(--shadow);position:relative;z-index:2}
.ucs-page .ucs-blueprint-question{font-size:13px;line-height:1.55;color:var(--text);padding:12px;background:var(--panel);border-radius:10px;margin-top:19px}
.ucs-blueprint-question>strong{display:block;font-size:10px;font-weight:500;margin-top:9px;color:var(--muted)}
.ucs-page .ucs-blueprint-response{font-size:14px;line-height:1.65;color:var(--text);margin-top:21px}
.ucs-source-citation,.ucs-blueprint-citations button{display:inline-flex;align-items:center;gap:5px;border:1px solid var(--border);background:var(--panel);color:var(--muted);border-radius:6px;padding:6px 8px;font-size:10px;line-height:1.5;min-height:30px}
.ucs-source-citation{margin-top:19px}
.ucs-blueprint-citations{display:flex;gap:6px;flex-wrap:wrap;margin-top:19px}
.ucs-blueprint-citations button[aria-pressed=true]{background:var(--selected-bg);border-color:var(--selected-border)}
.ucs-source-stack{position:relative;margin-top:27px;min-width:0}
.ucs-source-stack:before,.ucs-source-stack:after{content:"";position:absolute;inset:-9px 9px 8px;background:var(--panel);border:1px solid var(--border);border-radius:13px;z-index:-1}
.ucs-source-stack:after{inset:-17px 18px 14px;background:var(--panel);z-index:-2}
.ucs-blueprint-source{background:var(--surface);padding:16px 15px 21px;border:1px solid var(--border);border-radius:13px;box-shadow:var(--shadow);min-width:0}
.ucs-blueprint-source>.ucs-visual-file{margin-bottom:17px;padding:8px}
.ucs-blueprint-source>.ucs-kicker{font-size:10px}
.ucs-blueprint-source h4{line-height:1.4;letter-spacing:-.2px;margin-top:8px}
.ucs-blueprint-source .ucs-meta{font-size:10px;line-height:1.55}
.ucs-blueprint-source blockquote{font-size:12px;line-height:1.65;margin:17px 0 0;padding:12px;border-left:2px solid var(--border);background:var(--panel);border-radius:0 7px 7px 0;color:var(--muted)}
.ucs-source-control{margin-top:19px;border-top:1px solid var(--border);padding-top:12px}
.ucs-source-control strong{font-size:10px;line-height:1.5;font-weight:550}
.ucs-source-control p{font-size:11px;margin-top:6px;line-height:1.6}
.ucs-policy-source-label{display:inline-block;font-size:10px;margin-top:13px;color:var(--muted)}
@media(min-width:1450px){.ucs-workflows{gap:56px}}
@media(max-width:1000px){.ucs-workflows{grid-template-columns:290px minmax(0,1fr);gap:24px}
.ucs-workflow-stage{padding:16px}
.ucs-prompt-grid{grid-template-columns:repeat(4,minmax(0,1fr))}
.ucs-prompt-tile{grid-column:span 2}
.ucs-prompt-tile:where(:last-child:nth-child(odd)){grid-column:2 / span 2}
.ucs-hero-stage{padding:24px}
.ucs-evidence-detail{grid-template-columns:1fr}
.ucs-evidence-source{padding:22px}
.ucs-evidence-source blockquote{margin-top:13px}
.ucs-hero-result{grid-template-columns:minmax(0,1fr) 150px;gap:15px}
.ucs-result-count{padding:15px}
.ucs-record-choices>button{padding:9px}}
@media(max-width:700px){.ucs-hero-stage{margin-top:28px;padding:14px 12px 12px;border-radius:14px}
.ucs-frame-bar{padding:12px 14px}
.ucs-artifact-name{padding:10px 14px;font-size:11px}
.ucs-hero-conversation{padding:18px 16px}
.ucs-user-prompt{padding:14px;margin-bottom:22px}
.ucs-user-prompt>p{font-size:14px}
.ucs-file{font-size:13px;padding:6px 8px;min-height:33px}
.ucs-answer-heading{font-size:14px;flex-wrap:wrap;gap:7px}
.ucs-completed{font-size:10px;width:100%;margin-left:29px}
.ucs-hero-result{grid-template-columns:1fr;gap:12px}
.ucs-result-count{display:flex;flex-wrap:wrap;align-items:center;gap:10px;border-left:0;border-top:1px solid var(--border);padding:12px 0 0}
.ucs-result-count>strong{font-size:31px}
.ucs-result-count>strong>span{font-size:17px}
.ucs-result-count p{margin:0;font-size:12px;max-width:100px}
.ucs-result-count>span{margin:0 0 0 auto;font-size:10px}
.ucs-source-strip{gap:7px}
.ucs-source-strip>span{width:100%;font-size:11px;margin-bottom:2px}
.ucs-workflows{display:block;margin-top:26px}
.ucs-workflow-menu{flex-direction:row;overflow:auto;gap:18px;margin-bottom:24px;overscroll-behavior-x:contain;border:0}
.ucs-workflow-menu>button{white-space:nowrap;flex-shrink:0;min-height:44px;padding:10px 0;font-size:13px;gap:6px}
.ucs-workflow-menu>button>div{display:none}
.ucs-workflow-caption p{font-size:14px}
.ucs-workflow-stage{padding:12px;border-radius:12px}
.ucs-output-heading{padding:18px 15px}
.ucs-record-choices{padding:0 14px 15px;gap:5px}
.ucs-record-choices>button{min-height:72px;padding:8px}
.ucs-record-choices>button>span{font-size:10px}
.ucs-record-choices>button>strong{font-size:11px}
.ucs-evidence-source,.ucs-evidence-finding{padding:18px}
.ucs-evidence-source blockquote{font-size:14px}
.ucs-filter{padding:0 14px 15px;gap:5px}
.ucs-filter>button{font-size:10px;min-height:33px;padding:7px 8px}
.ucs-page table{min-width:480px}
.ucs-stage-register table{min-width:0;table-layout:fixed}
.ucs-stage-register thead th{white-space:normal;line-height:1.35;font-size:10px}
.ucs-stage-register thead th:nth-child(1){width:34%}
.ucs-stage-register thead th:nth-child(2){width:22%}
.ucs-stage-register thead th:nth-child(3){width:14%;white-space:nowrap}
.ucs-stage-register thead th:nth-child(4){width:30%}
.ucs-page thead th,.ucs-page tbody th,.ucs-page td{padding:10px 12px}
.ucs-stage-register thead th,.ucs-stage-register tbody th,.ucs-stage-register td{padding:10px 6px;overflow-wrap:anywhere}
.ucs-stage-register td:nth-child(3){white-space:nowrap}
.ucs-stage-register .ucs-table-status{padding:4px 5px}
.ucs-workflow-prompt{padding:17px}
.ucs-workflow-prompt>p{font-size:12px}
.ucs-email{padding:0 17px 18px}
.ucs-prompt-grid{grid-template-columns:1fr;margin-top:25px}
.ucs-page .ucs-prompt-tile{grid-column:auto}
.ucs-prompt-tile>p{font-size:14px;line-height:1.65}
.ucs-faq>div{margin-top:26px}
.ucs-faq summary{font-size:14px;min-height:24px}
.ucs-file-preview{max-height:340px;padding:14px}
.ucs-evidence-detail-compact .ucs-evidence-source,.ucs-evidence-detail-compact .ucs-evidence-finding{padding:17px}}
@media(max-width:1100px){.ucs-blueprint-grid{grid-template-columns:1fr;max-width:820px;margin-inline:auto}
.ucs-blueprint-copy{min-height:0}
.ucs-blueprint-stage{min-height:350px;grid-template-columns:minmax(0,1.2fr) minmax(0,1fr);gap:26px;padding:32px}
.ucs-blueprint-source blockquote{font-size:14px}
.ucs-page .ucs-blueprint-question{font-size:14px}
.ucs-page .ucs-blueprint-response{font-size:15px}
.ucs-blueprint-card+.ucs-blueprint-card{margin-top:26px}}
@media(max-width:800px){.ucs-workflows{display:block}
.ucs-workflow-menu{flex-direction:row;overflow:auto;gap:18px;overscroll-behavior-x:contain;border:0}
.ucs-workflow-menu>button{white-space:nowrap;flex-shrink:0;min-height:44px;padding:10px 0;font-size:13px;gap:6px}
.ucs-workflow-menu>button>div{display:none}
.ucs-workflow-copy{margin-top:24px}
.ucs-workflow-caption{margin-bottom:18px}
.ucs-workflow-prompt{margin-bottom:24px}
.ucs-workflow-panels{width:100%}
.ucs-workflow-prompt .ucs-file{width:auto}}
@media(max-width:700px){.ucs-feature-card{flex-basis:88%;min-width:0}
.ucs-capability-rail{gap:16px}
.ucs-feature-copy{padding:25px 23px 20px;min-height:175px}
.ucs-feature-card>a{padding:18px 23px 22px}
.ucs-card-composition{height:360px}
.ucs-mini-paper{left:40px;right:16px;padding:17px 16px}
.ucs-floating-prompt{left:14px;right:21px;bottom:23px}
.ucs-rail-controls{margin:24px 0 20px}
.ucs-blueprint-grid{gap:22px;margin-top:27px}
.ucs-blueprint-stage{grid-template-columns:1fr;gap:23px;min-height:0;padding:22px 18px 27px}
.ucs-source-stack{margin:0 9px}
.ucs-blueprint-source blockquote{font-size:14px}
.ucs-blueprint-source .ucs-meta{font-size:12px}
.ucs-source-control strong{font-size:12px}
.ucs-source-control p{font-size:13px}
.ucs-blueprint-source>.ucs-kicker{font-size:11px}
.ucs-visual-file strong{font-size:12px}
.ucs-visual-file small{font-size:10px}
.ucs-blueprint-answer{padding:20px}
.ucs-faq>h2{text-align:left}
.ucs-workflow-prompt>p{font-size:13px}
.ucs-workflow-menu{margin-bottom:0}}
@media(max-width:380px){.ucs-stage-register thead th:nth-child(1){width:30%}
.ucs-stage-register thead th:nth-child(2){width:23%}
.ucs-stage-register thead th:nth-child(3){width:17%}
.ucs-stage-register thead th:nth-child(4){width:30%}
.ucs-stage-register thead th,.ucs-stage-register tbody th,.ucs-stage-register td{padding-inline:5px}
.ucs-stage-register td{font-size:10.5px}
.ucs-stage-register .ucs-row-button span{font-size:11px}
.ucs-stage-register .ucs-table-status{font-size:9.5px;padding-inline:4px}}
@media(prefers-reduced-motion:reduce){.ucs-page *{scroll-behavior:auto!important;transition:none!important;animation:none!important}}
.ucs-hero-stage{width:100%}


.ucs-faq>div{width:100%;max-width:900px;margin:30px auto 0}

@media (max-width:700px) {
  .ucs-hero-stage { padding: 12px; }
  .ucs-card-composition { padding-inline: 12px; }
  .ucs-mini-paper { padding: 12px; }
  .ucs-user-prompt { padding: 12px; }
}
